import { openBlock as t, createElementBlock as l, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function n(a, e) {
  return t(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M10 3.333a5.834 5.834 0 0 1 5.834 5.833l-.008.3a5.8 5.8 0 0 1-1.59 3.71l2.96 2.96-1.06 1.06-3.07-3.069A5.8 5.8 0 0 1 10 15l-.3-.008A5.834 5.834 0 0 1 10 3.333m0 1.5a4.334 4.334 0 1 0 .001 8.667A4.334 4.334 0 0 0 10 4.833"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
